import React from "react";
import { Grid } from "react-bootstrap";
import { Collapse, Glyphicon } from "react-bootstrap";
import { CubeDifferencesItem } from "./CubeDifferencesItem";
import { CustomTooltip } from "../tooltip/CustomTooltip";

export class CubeRoleGroupDifferences extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true,
    };
  }

  handleCollapse = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  getRoleLabel(type) {
    switch (type.toLowerCase()) {
      case "d":
        return "Dimensions";
      case "o":
        return "Observations";
      case "a":
        return " Complementary attributes";
      default:
        return "";
    }
  }

  render() {
    const { type, items, searchExpr } = this.props;

    const filteredItems = items?.filter((item) => {
      // item having csi
      if (searchExpr) {
        const codesInCsi = [
          item.object.cubeVariableCode
            ? item.object.cubeVariableCode.toLowerCase()
            : "",
          item.object.attributeAssociatedVariable
            ? item.object.attributeAssociatedVariable.toLowerCase()
            : "",
        ];
        const namesInNestedObjects = item.items.map((i) =>
          i.object.name ? i.object.name.toLowerCase() : ""
        );
        const codesInNestedObjects = item.items.map((i) =>
          i.object.code ? i.object.code.toLowerCase() : ""
        );
        return (
          codesInCsi.some((code) => code.includes(searchExpr.toLowerCase())) ||
          namesInNestedObjects.some((name) =>
            name.includes(searchExpr.toLowerCase())
          ) ||
          codesInNestedObjects.some((code) =>
            code.includes(searchExpr.toLowerCase())
          )
        );
      } else {
        return true;
      }
    });
    const filteredItemsLength = filteredItems.length;
    return (
      <div className="custom-panel">
        <div className="custom-panel-heading">
          <h5 onClick={this.handleCollapse}>
            <Glyphicon
              glyph={this.state.open ? "chevron-down" : "chevron-right"}
              onClick={this.handleCollapse}
            />{" "}
            {this.getRoleLabel(type)} ({filteredItemsLength}/{items.length})
          </h5>
          <CustomTooltip type={type} />
        </div>

        <Collapse in={this.state.open}>
          <div className="custom-panel-body">
            <div className="item-list-container">
              <Grid className="cube-structure-item" fluid={true}>
                {filteredItems.length
                  ? filteredItems.map((item, key) => (
                      <CubeDifferencesItem diffItems={[item]} key={key} />
                    ))
                  : "Nothing found"}
              </Grid>
            </div>
          </div>
        </Collapse>
      </div>
    );
  }
}

export default CubeRoleGroupDifferences;
